import { render, staticRenderFns } from "./AgreeModal.vue?vue&type=template&id=1ab22cb4&scoped=true&"
import script from "./AgreeModal.vue?vue&type=script&lang=js&"
export * from "./AgreeModal.vue?vue&type=script&lang=js&"
import style0 from "./AgreeModal.vue?vue&type=style&index=0&id=1ab22cb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab22cb4",
  null
  
)

export default component.exports